import { IMeetingPlaceLinkToAnyPage } from '../queries/fragments/meetingPlaceLinkToAnyPage';
import { normalizeTextString } from './normalizeTextString';
import { calculatePrefixPath } from './rendered-page-creation/calculate-prefixed-path';

export const generateCorrectSlug = (
  link: IMeetingPlaceLinkToAnyPage,
): string => {
  return link?.customizedSlug
    ? calculatePrefixPath(link?.customizedSlug)
    : `${calculatePrefixPath(
        `/${link?.node_locale?.toLowerCase()}`,
      )}/${normalizeTextString(link?.slug, true)}`;
};

export const generateCorrectSlugForPage = (page: {
  slug: string;
  customizedSlug: string;
  node_locale: string;
}): string => {
  const pagePrefixAndLocale = calculatePrefixPath(
    `/${page.node_locale?.toLocaleLowerCase()}`,
  );

  return page.customizedSlug
    ? page.customizedSlug
    : normalizeTextString(page.slug, true)
    ? `${pagePrefixAndLocale}/${normalizeTextString(page.slug, true)}`
    : `${pagePrefixAndLocale}/`;
};
